import { memo, useMemo } from "react";
import { RuleBasedAudienceSummary } from "features/mediaDataRoom/components";
import {
  ALL_PUBLISHER_USERS_AUDIENCE,
  MediaDataRoomVersion,
  type RuleBasedAudienceAb,
} from "features/mediaDataRoom/models";
import { mapRulesBasedAudienceToAudienceRulesTree } from "features/mediaDataRoom/utils";
import { useAudiences } from "features/mediaDataRoom/wrappers";

interface AudienceAbDrawerRuleBasedDetailsProps {
  audience: RuleBasedAudienceAb;
}

const AudienceAbDrawerRuleBasedDetails =
  memo<AudienceAbDrawerRuleBasedDetailsProps>(({ audience }) => {
    const { audiences } = useAudiences(MediaDataRoomVersion.ab);
    const audienceTree = useMemo(
      () =>
        mapRulesBasedAudienceToAudienceRulesTree(
          audience,
          (audiences.computeResults || []).reduce(
            (acc, { id, name }) => ({ ...acc, [id]: name }),
            {
              [ALL_PUBLISHER_USERS_AUDIENCE.id]:
                ALL_PUBLISHER_USERS_AUDIENCE.name,
            }
          )
        ),
      [audience, audiences]
    );
    return <RuleBasedAudienceSummary audience={audienceTree} />;
  });

AudienceAbDrawerRuleBasedDetails.displayName =
  "AudienceAbDrawerRuleBasedDetails";

export default AudienceAbDrawerRuleBasedDetails;
